import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { timeLogApi } from '../services/api';
import { CreateTimeLogEntry } from '../types/api';

export const TIME_LOGS_KEY = ['time-logs'] as const;

export const useTimeLogs = () =>
  useQuery({ queryKey: TIME_LOGS_KEY, queryFn: timeLogApi.getAll });

export const useCreateTimeLog = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (entry: CreateTimeLogEntry) => timeLogApi.create(entry),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TIME_LOGS_KEY }),
  });
};

export const useUpdateTimeLog = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<CreateTimeLogEntry> }) =>
      timeLogApi.update(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TIME_LOGS_KEY }),
  });
};

export const useDeleteTimeLog = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => timeLogApi.delete(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TIME_LOGS_KEY }),
  });
};
